module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/right_arrow_with_circle-6114b28a7f794558b46c15660585f229.svg";